import React from "react";
import { Link } from "react-router-dom";
import "../styles.css";
import ArtishPostList from "../components/ArtistPostList";

const Home = () => {
  return (
    <div className="page-container">
      <section className="home-store-banner">
        <p className="eyebrow">Now serving the Central Highlands in person</p>
        <h1>X Fire Music — Emerald</h1>
        <p>
          Visit our music store at 10 Hospital Rd, Emerald for instruments,
          accessories, advice and local service.
        </p>
        <Link className="store-btn primary" to="/shop">Store Details &amp; Directions</Link>
      </section>

      <h1>Latest News</h1>
      <p className="contact">
        Need to reach us? <a href="mailto:info@xfiremusic.com.au">info@xfiremusic.com.au</a>
      </p>

      <ArtishPostList artistPageId={12}/>
    </div>
  );
};

export default Home;
